module.exports = __webpack_public_path__ + "static/media/侯晨钟@2x.920fa7b7.png";